import FAQ, { FaqProps } from '../../../ui/customer-support/components/faq';

type Props = {
  data: FaqProps;
};

const FaqIntTastic = ({ data }: Props) => {
  return <FAQ {...data} />;
};

export default FaqIntTastic;
